import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("TarefaFilter")
export class TarefaFilter {

  id: number;
}
